import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { Grid, Paper, Typography } from '@mui/material';

const styleSheet = theme => ({
  paper: {
    marginTop: 16,
    paddingTop: 16,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 20,
    color: theme.palette.text.secondary,
  },
  dbTile: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 150,
    width: 180
  },
  dbTileSelected: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 150,
    width: 180,
    backgroundColor: '#D3D3D3'
  }
});

class ProgramType extends Component {

  state = {

  };

  handleTileClick(type) {
    if (this.props.changeType) {
      this.props.changeType(type);
    }
  }

  render() {
    const classes = this.props.classes;

    return (
      <div>
        <Typography variant="h6">Plan type</Typography>
        <Typography variant="body2">
          AppBind supports several types of incentive payout programs
        </Typography>

        <Grid container spacing={2} justifyContent="flex-start" style={{ marginTop: 8 }}>
          <Grid item>
            <Grid container spacing={2}>
              <Grid item>
                <Paper className={(this.props.type === 0 ? classes.dbTileSelected : classes.dbTile)} onClick={() => { this.handleTileClick(0) }}>
                  <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                    <Grid item>
                      <Typography variant="h6">
                        Instant rebate
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="body2" style={{ marginTop: 2 }}>
                        Offer rebates on subscriptions purchased through AppBind. Rebates will be applied once a subscription purchase clears.
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </Grid>

          <Grid item>
            <Grid container spacing={2}>
              <Grid item>
                <Paper className={(this.props.type === 1 ? classes.dbTileSelected : classes.dbTile)} onClick={() => { this.handleTileClick(1) }}>
                  <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                    <Grid item>
                      <Typography variant="h6">
                        Monthly rebate
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="body2" style={{ marginTop: 2 }}>
                        At the end of the month, calculate a sales commission based on volume during the month. Commission is paid as a rebate to the reseller.
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </Grid>

          {/*<Grid item>
            <Grid container spacing={2}>
              <Grid item>
                <Paper className={(this.props.type === 2 ? classes.dbTileSelected : classes.dbTile)} onClick={() => { this.handleTileClick(2) }}>
                  <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                    <Grid item>
                      <Typography variant="h6">
                        Monthly Credits
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="body2" style={{ marginTop: 2 }}>
                        At the end of the month, calculate a sales commission based on volume during the month.  Commission is paid as credits that the reseller can apply to future purchases.
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </Grid>*/}

          {/*<Grid item>
            <Grid container spacing={2}>
              <Grid item>
                <Paper className={(this.props.type === 3 ? classes.dbTileSelected : classes.dbTile)} onClick={() => { this.handleTileClick(3) }}>
                  <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                    <Grid item>
                      <Typography variant="h6">
                        Prepaid Credits
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="body2" style={{ marginTop: 2 }}>
                        Allow resellers to buy credits up front at a discount to be applied to future purchases.
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </Grid>*/}

          <Grid item>
            <Grid container spacing={2}>
              <Grid item>
                <Paper className={(this.props.type === 4 ? classes.dbTileSelected : classes.dbTile)} onClick={() => { this.handleTileClick(4) }}>
                  <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                    <Grid item>
                      <Typography variant="h6">
                        Referral commission
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="body2" style={{ marginTop: 2 }}>
                        At the end of the month, calculate a sales commission based on external volume during the month. Commission is paid as a rebate to the reseller.
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </Grid>

        </Grid>
      </div>
    );

  }
}

export default withStyles(styleSheet)(ProgramType);